import {
  Flex,
  Icon,
  LinkAnchor,
  Notification,
  NotificationProps,
  Typo,
} from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { useProposalFormData } from '../../../hooks/adjustments/proposal'
import { useEditProposal } from '../../../hooks/proposal'
import { TKey, useWriskTranslation } from '../../../infrastructure/internationalisation'
import { getPromotionDisclosureConfig } from '../../../state/configuration'
import { isValidForm } from '../../formBuilder'
import { useProduct } from '../../product/ProductProvider'
import { useProposal } from '../../product/proposal/ProposalProvider'

const tKey = TKey('components.promotion-notification')

export interface PromotionNotificationProps extends NotificationProps {
  promoCode: string
}

export const PromotionNotification: FunctionComponent<PromotionNotificationProps> = ({
  promoCode,
  ...props
}) => {
  const { t } = useWriskTranslation()

  const { product } = useProduct()
  const { proposal } = useProposal()

  const handleReview = useEditProposal(proposal)

  const promoDisclosure = getPromotionDisclosureConfig(product)

  const form = promoDisclosure?.promotions?.[promoCode]?.form ?? []

  const promoData = useProposalFormData(form)

  const isValid = isValidForm(form, promoData)

  const variant = isValid ? 'critical' : 'warning'

  return (
    <Notification
      variant={variant}
      type='standalone'
      flexDirection={['column', 'column', 'row']}
      alignItems={['flex-start', 'flex-start', 'center']}
      {...props}
    >
      <Flex justifyContent='flex-start' mr={[0, 0, 2]} mb={[4, 4, 0]}>
        <Icon display={['none', 'none', 'block']} icon='warning' mr={3} />
        <Typo>{t(tKey(variant, promoCode, 'notification'))}</Typo>
      </Flex>
      <LinkAnchor variant='standalone' onClick={handleReview} typoSize='sm'>
        {t(tKey('actions', 'review'))}
      </LinkAnchor>
    </Notification>
  )
}
